import * as React from "react";
import { type HeadFC, type PageProps } from "gatsby";
import HeroSection from "../components/HeroSection";
import Navigation from "../components/Navigation";
import ProductShowcase1 from "../components/ProductShowcase1";
import ProductShowcase2 from "../components/ProductShowcase2";
import ProductShowcase3 from "../components/ProductShowcase3";
import ProductShowcase4 from "../components/ProductShowcase4";
import OurStory from "../components/OurStory";
import Pricing from "../components/Pricing";
import GettingSetup from "../components/GettingSetup";
import Footer from "../components/Footer";

const IndexPage: React.FC<PageProps> = () => {
  return (
    <div className="max-w-xl" style={{ margin: "auto" }}>
      <Navigation />
      <HeroSection />
      <ProductShowcase1 />
      <ProductShowcase2 />
      <ProductShowcase3 />
      <ProductShowcase4 />
      <OurStory />
      <Pricing />
      <GettingSetup />
      <Footer />
    </div>
  );
};

export default IndexPage;

export const Head: HeadFC = () => <title>NoFi</title>;
